// AUTO-GENERATED -- do not edit manually
// Generated by scripts/generate-active-plugins.js based on dist/ contents
import { EnvironmentProviders, Provider } from '@angular/core';
import { createLazyPluginInitializer, ALLY_SERVICE } from 'core-client/api';
import { AllyService } from 'ally';

export const OPTIONAL_TOKEN_PROVIDERS: Provider[] = [
  { provide: ALLY_SERVICE, useExisting: AllyService },
];

export const OPTIONAL_PLUGIN_PROVIDERS: EnvironmentProviders[] = [
  createLazyPluginInitializer('Ally', () => import('ally').then(m => m.AllyService)),
  createLazyPluginInitializer('astimax', () => import('astimax').then(m => m.AstimaxService)),
];
